import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@one-thd/sui-atomic-components';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { CreateAProject } from '@thd-olt-component-react/project-forms';
import {
  handleProjectCreationFromNullState,
  triggerProjectsInteractionAnalytics,
} from '../../utils/helpers';

const NullStateCreateProjectAction = ({
  cacheKey,
  componentId,
  buttonText,
  fullWidth: isFullWidth,
}) => {
  return (
    <QueryProvider cacheKey={cacheKey}>
      <CreateAProject
        // eslint-disable-next-line max-len
        onCreate={(newProject) => handleProjectCreationFromNullState({ newProject, hasProjects: false, componentId })}
        CustomCreateProjectActionElement={({ onClick }) => {
          const handleCreateClick = (event) => {
            triggerProjectsInteractionAnalytics({
              action: 'button-click',
              id: componentId,
              component: 'create new',
            });
            onClick(event);
          };

          return (
            <Button
              variant="primary"
              fullWidth={isFullWidth}
              onClick={handleCreateClick}
              data-component-id={componentId}
              aria-label="Create New Project"
            >
              {buttonText}
            </Button>
          );
        }}
      />
    </QueryProvider>
  );
};

NullStateCreateProjectAction.propTypes = {
  cacheKey: PropTypes.string.isRequired,
  componentId: PropTypes.string,
  buttonText: PropTypes.node,
  fullWidth: PropTypes.bool,
};

NullStateCreateProjectAction.defaultProps = {
  componentId: '',
  buttonText: 'Create New',
  fullWidth: true,
};

export default NullStateCreateProjectAction;
